var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.903,
    height: 12.927,
    viewBox: "0 0 12.903 12.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-phone-outgoing",
    "data-name": "Icon feather-phone-outgoing",
    transform: "translate(-3.168 -0.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_56",
    "data-name": "Trazado 56",
    d: "M29,5V1.5H25.5",
    transform: "translate(-13.639)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_57",
    "data-name": "Trazado 57",
    d: "M24,5.587,28.087,1.5",
    transform: "translate(-12.723)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_58",
    "data-name": "Trazado 58",
    d: "M14.78,11.711v1.752a1.168,1.168,0,0,1-1.273,1.168,11.555,11.555,0,0,1-5.039-1.793,11.386,11.386,0,0,1-3.5-3.5A11.555,11.555,0,0,1,3.173,4.273,1.168,1.168,0,0,1,4.334,3H6.086A1.168,1.168,0,0,1,7.254,4a7.5,7.5,0,0,0,.409,1.641A1.168,1.168,0,0,1,7.4,6.877l-.742.742a9.342,9.342,0,0,0,3.5,3.5l.742-.742a1.168,1.168,0,0,1,1.232-.263,7.5,7.5,0,0,0,1.641.409A1.168,1.168,0,0,1,14.78,11.711Z",
    transform: "translate(0 -0.916)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phoneCall.f8b2025b6ac3aa627e52b98ed1f8cf04.svg";
export { ForwardRef as ReactComponent };